export default __webpack_public_path__ + "static/media/subs.3c452c2a.png";